import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchSiteConfigurationHistory } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const SiteConfigurationChartSlice: Slice<any, {}, "SiteConfigurationChartSlice"> = createSlice({
    name: "SiteConfigurationChartSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchSiteConfigurationHistory.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchSiteConfigurationHistory.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchSiteConfigurationHistory.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default SiteConfigurationChartSlice
